export default __webpack_public_path__ + "KaTeX_Size4-Regular.4f012d6a01b53cb21970a91e4ad0e314.woff2";